// extracted by mini-css-extract-plugin
module.exports = {"Container":"Spinner_Container__2unwT","Spinner":"Spinner_Spinner__2L6qb","big":"Spinner_big__3VwBH","spin-fast":"Spinner_spin-fast__2ahIh","small":"Spinner_small__16UZd"};